import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      background: theme.palette.primary.contrastText,
      marginBottom: theme.spacing(4),
      borderRadius: '7px',
      padding: '16px 8px 8px 8px',
    },
  },
  mobileHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    '& span': {
      fontFamily: 'Nunito Sans',
      letterSpacing: '1px',
    },
  },
  baseWrapper: {
    width: '100%',
    height: '190px',
    justifyContent: 'space-between',
    background: theme.palette.primary.contrastText,
    display: 'flex',
    marginBottom: theme.spacing(3),
  },
  teamWrapper: ({ isSinglePlayer }) => ({
    width: '100%',
    height: '190px',
    display: 'flex',
    background: theme.palette.primary.contrastText,
    [theme.breakpoints.up('md')]: {
      minWidth: '400px',
    },
    '&.intl': {
      borderRight: `4px solid ${theme.palette.ryderCup.intl}`,
    },
    '&.usa': {
      borderLeft: `4px solid ${theme.palette.ryderCup.usa}`,
    },
    '&.winner': {
      '& h2,h4,h6': {
        color: theme.palette.primary.contrastText,
      },
    },
    '&.winner.usa': {
      background: theme.palette.ryderCup.usa,
      '&:after': {
        content: '""',
        display: 'inline-block',
        width: isSinglePlayer ? '50%' : '25%',
        height: '100%',
        borderTop: '95px solid #fff',
        borderBottom: '95px solid #fff',
        borderLeft: `30px solid ${theme.palette.ryderCup.usa}`,
      },
    },
    '&.winner.intl': {
      background: theme.palette.ryderCup.intl,
      '&:before': {
        content: '""',
        display: 'inline-block',
        width: isSinglePlayer ? '50%' : '25%',
        height: '100%',
        borderTop: '95px solid #fff',
        borderBottom: '95px solid #fff',
        borderRight: `30px solid ${theme.palette.ryderCup.intl}`,
      },
    },
  }),
  mobileBase: {
    display: 'flex',
    marginBottom: theme.spacing(1),
    width: '100%',
    justifyContent: 'space-between',
    borderRadius: '6px',
    '&.neutral': {
      background: 'rgba(130, 130, 130, 0.07)',
    },
    '&.usa.leader': {
      border: `1px solid ${theme.palette.ryderCup.usa}`,
    },
    '&.intl.leader': {
      border: `1px solid ${theme.palette.ryderCup.intl}`,
    },
    '&.intl': {
      '& .winner': {
        color: theme.palette.ryderCup.intl,
      },
    },
    '&.usa': {
      '& .winner': {
        color: theme.palette.ryderCup.usa,
      },
    },
    '&.winner.usa': {
      background: theme.palette.ryderCup.usa,
      '& h2,h4,h6': {
        color: theme.palette.primary.contrastText,
      },
    },
    '&.winner.intl': {
      background: theme.palette.ryderCup.intl,
      '& h2,h4,h6': {
        color: theme.palette.primary.contrastText,
      },
    },
  },
  action: {
    color: theme.palette.ryderCup.usa,
    '& span.MuiButton-endIcon': {
      border: `1px solid ${theme.palette.ryderCup.usa}`,
      borderRadius: '50%',
    },
  },
  flag: {
    marginTop: '24px',
  },
  mobileFlag: {
    width: '34px',
    minWidth: '34px',
    height: '23px',
    borderRadius: '4px 0 0 0',
  },
}))

export default useStyles
